module.exports = __webpack_public_path__ + "img/profile-user.19323a3f.svg";